module.exports = __webpack_public_path__ + "img/3x.c3c3a3c.jpg";